import React from "react";
import { Image } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import logoImg from "../../../assets/svg/isosustemia 1.svg";
import "./Privacidad.scss";

export function Privacidad() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <nav className="landing-nav">
        <div className="landing-nav__left" onClick={() => navigate("/admin")} style={{ cursor: "pointer" }}>
          <Image src={logoImg} className="landing-nav__logo-img" />
          <span className="landing-nav__brand">sustemia</span>
        </div>
      </nav>

      <main className="legal-page__content">
        <div className="legal-page__card">
          <h1 className="legal-page__title">Política de Privacidad</h1>
          <p className="legal-page__subtitle">Sistema de Seguridad e Higiene</p>
          <p className="legal-page__updated">Última actualización: 2026</p>

          <p className="legal-page__intro">
            Nos comprometemos a proteger la privacidad y seguridad de la información gestionada en la plataforma.
          </p>

          <section className="legal-page__section">
            <h2>1. Datos recopilados</h2>
            <p>Se recopilan:</p>
            <ul>
              <li>Datos personales (nombre, email, teléfono, etc.)</li>
              <li>Información de empresas</li>
              <li>Datos relacionados con seguridad e higiene (accidentes, incidentes, evaluaciones de riesgo, inspecciones, registros)</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>2. Finalidad</h2>
            <p>Los datos se utilizan para:</p>
            <ul>
              <li>Gestionar la seguridad y salud laboral</li>
              <li>Registrar incidentes y evaluaciones</li>
              <li>Generar reportes y cumplimiento normativo</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>3. Base legal</h2>
            <p>
              El tratamiento se basa en el consentimiento del usuario y la relación contractual.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>4. Transferencia internacional</h2>
            <p>
              Los datos pueden ser almacenados y procesados en servidores ubicados en distintos países.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>5. Derechos del usuario</h2>
            <p>El usuario puede:</p>
            <ul>
              <li>Acceder a sus datos</li>
              <li>Rectificarlos</li>
              <li>Solicitar su eliminación</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>6. Seguridad</h2>
            <p>
              Se aplican medidas técnicas y organizativas para proteger la información.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>7. Responsabilidad del usuario</h2>
            <p>
              El usuario declara contar con autorización para cargar datos personales de terceros en el sistema.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>8. Contacto</h2>
            <p>
              <a href="mailto:soporte@sustemia.com">soporte@sustemia.com</a>
            </p>
          </section>

          <div className="legal-page__back">
            <button className="legal-page__back-btn" onClick={() => navigate("/admin")}>
              ← Volver
            </button>
          </div>
        </div>
      </main>

      <footer className="legal-page__footer">
        <span>© 2026 Sustemia</span>
        <span className="legal-page__footer-sep">|</span>
        <span
          className="legal-page__footer-link"
          onClick={() => navigate("/privacidad")}
        >
          Política de Privacidad
        </span>
        <span className="legal-page__footer-sep">|</span>
        <span
          className="legal-page__footer-link"
          onClick={() => navigate("/terminos")}
        >
          Términos y Condiciones
        </span>
      </footer>
    </div>
  );
}
